<template>
    <Modal :value='true' width="360" :mask-closable='false' @on-cancel="cancel" v-bind="$attrs">
        <p slot="header" style="color:#f60;text-align:center">
            <Icon type="information-circled"></Icon>
            <span v-html="title"></span>
        </p>
        <div style="text-align:center">
            <p><slot><span v-html="desc|| $t('global.modal.confirm', { defaultValue: '确定' })+' '+ title+'？'"></span></slot></p>
            <Spin size="large" fix v-if="loading"></Spin>
        </div>
        <div slot="footer">
            <Button type="error" size="large" long  @click="confirm">{{$t('global.common.update_OK',{defaultValue:'确定'})}}</Button>
        </div>
    </Modal>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: "删除",
        },
        desc: String
    },
    data() {
        return {
            loading: false
        }
    },

    methods: {
        confirm() {
            this.loading = true;
            this.$emit('on-confirm')
        },
        cancel() {
            this.$emit('on-close');
        },
    }
}
</script>
